/**
* GENERATED BY KRPC GEN - LESS MODIFY BY HAND
* redpack-service.ts  2025-08-12T13:43:44+08:00
*/
import type { R, RpcService, MethodConfig as M, PagedQuery, PagedList } from 'krpc-base';

import type { QueryMyRpInfo, IncreaseTaskReq, RpRecord, IncreaseTaskRst, RpTask, MyRpRecord, RpGrabRst, MyRpInfo } from './wy-dto';

const _ = 'RedPack/';

export class RedPackService {

  constructor(readonly r: RpcService) {}
  // 获取用户可使用的红包雨次数
  activityTips(m?: M): R<number>{
    return this.r.async(_ + 'activityTips', undefined, m);
  }
  // 用户抢红包
  grabRedPack(m?: M): R<RpGrabRst>{
    return this.r.async(_ + 'grabRedPack', undefined, m);
  }
  // 各种活动任务增加红包雨次数 返回剩余红包雨次数
  increaseLotteryNum(d:IncreaseTaskReq, m?: M): R<IncreaseTaskRst>{
    return this.r.async(_ + 'increaseLotteryNum', d, m);
  }
  // 获取用户所得红包总金额(金额单位：分)
  myRedPackInfo(m?: M): R<MyRpInfo>{
    return this.r.async(_ + 'myRedPackInfo', undefined, m);
  }
  // 获取用户获取红包记录
  myRpRecordList(d:PagedQuery<QueryMyRpInfo>, m?: M): R<PagedList<MyRpRecord>>{
    return this.r.async(_ + 'myRpRecordList', d, m);
  }
  // 获取用户任务列表
  myTaskInfo(m?: M): R<Array<RpTask>>{
    return this.r.async(_ + 'myTaskInfo', undefined, m);
  }
  // 查询已获取红包用户记录(免登)
  redPackRecordList(m?: M): R<Array<RpRecord>>{
    return this.r.async(_ + 'redPackRecordList', undefined, m);
  }
}
